module.exports = __webpack_public_path__ + "img/knu_gallery16.7cc96535.jpg";